import styled from 'styled-components'
import { Box, Card, CardBody, Flex, Heading, Text, NextLinkFromReactRouter, ArrowForwardIcon } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { PageMeta } from 'components/Layout/Page'

/**
 * 2026-10-01: /legacy — the one place the parked products are linked from (footer "Legacy products"). Lottery and migration
 * are out of the main navigation (3–4 users a month); their pages stay reachable here and by direct URL for old claims.
 * 2026-10-08: Click to Win is archived, not legacy (Bez; archive/click-to-win-20261008): it is not listed here, /click-to-win redirects to /swap.
 */
const Page = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 32px 16px 64px;
  min-height: calc(100vh - 64px);
`

const Row = styled(NextLinkFromReactRouter)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-radius: 16px;
  color: inherit;
  &:hover {
    background: ${({ theme }) => theme.colors.backgroundAlt2 ?? theme.colors.background};
  }
`

const LEGACY = (t: (s: string) => string) => [
  { title: t('Lottery'), desc: t('Paused. Prizes from the finished rounds stay claimable.'), href: '/lottery', cta: t('Claim old prizes') },
  { title: t('Token migration'), desc: t('Paused. CADINU V1 to V2 migration still works here.'), href: '/migration', cta: t('Migrate') },
]

const Legacy = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageMeta />
      <Page data-testid="legacy-page">
        <Heading as="h1" scale="xl" mb="8px">
          {t('Legacy products')}
        </Heading>
        <Text color="textSubtle" mb="24px">
          {t('Products that are paused. Old prizes and rewards remain claimable; a new CBON-based version is planned.')}
        </Text>
        <Card>
          <CardBody p="8px">
            {LEGACY(t).map((item) => (
              <Row key={item.href} to={item.href} data-testid={`legacy-${item.href.slice(1)}`}>
                <Box>
                  <Text bold fontSize="18px">
                    {item.title}
                  </Text>
                  <Text color="textSubtle" fontSize="14px">
                    {item.desc}
                  </Text>
                </Box>
                <Flex alignItems="center" flexShrink={0}>
                  <Text color="primary" bold fontSize="14px" mr="4px">
                    {item.cta}
                  </Text>
                  <ArrowForwardIcon color="primary" />
                </Flex>
              </Row>
            ))}
          </CardBody>
        </Card>
      </Page>
    </>
  )
}

export default Legacy
